// extracted by mini-css-extract-plugin
module.exports = {"all":"Products_all__3NlgM","container":"Products_container__16eXx","box":"Products_box__15GIi"};